var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuscador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.44,6.32l-2.51,0.67l0,0l-15.45,4.15l0,0l-2.61,0.68l-0.02,0.01l-0.7,2.62L7,29.92l-0.67,2.51L21.4,47.5l0,0l0.08,0.08 l10.58-2.83c1.32-0.35,2.74,0.02,3.71,0.99l17.7,17.73c2.36,2.36,6.09,2.95,8.89,1.15c3.94-2.53,4.36-7.86,1.24-10.98L45.75,35.77 c-0.97-0.97-1.35-2.38-0.99-3.71l2.83-10.58l0,0L32.44,6.32z M42.35,22.89l-2.13,7.96c-0.79,2.95,0.05,6.09,2.21,8.25l17.78,17.8 c0.78,0.78,1.02,2,0.45,2.94c-0.83,1.36-2.64,1.52-3.69,0.47L39.1,42.42c-2.16-2.16-5.3-3-8.25-2.21l-7.96,2.13L11.66,31.11 l4.11-15.34l15.34-4.11L42.35,22.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.68,15.21l-7.28,1.95c-1.58,0.42-2.82,1.66-3.24,3.24l-1.95,7.28c-0.42,1.58,0.03,3.27,1.19,4.43l5.33,5.33 c1.16,1.16,2.85,1.61,4.43,1.19l7.28-1.95c1.58-0.42,2.82-1.66,3.24-3.24l1.95-7.28c0.42-1.58-0.03-3.27-1.19-4.43l-5.33-5.33 C30.95,15.23,29.26,14.78,27.68,15.21z M32.33,32.33c-2.99,2.99-7.84,2.99-10.83,0c-2.99-2.99-2.99-7.84,0-10.83s7.84-2.99,10.83,0 C35.32,24.49,35.32,29.34,32.33,32.33z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscador);
export default __webpack_public_path__ + "static/media/buscador.06d85e90a487b4cbf37208424d11d2e3.svg";
export { ForwardRef as ReactComponent };